module.exports = __webpack_public_path__ + "5392fed2f8b27b12eb88028bee8f3cfc.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/cart-18.svg
// module id = 521
// module chunks = 73